// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/views/Dimension/components/HolesConfiguration/styles.scss
// module id = 1311
// module chunks = 0